import React from 'react';

const bursts = [
  { top: '30%', left: '40%', delay: '0s' },
  { top: '55%', left: '65%', delay: '0.7s' },
  { top: '25%', left: '70%', delay: '1.4s' },
  { top: '60%', left: '30%', delay: '2.1s' },
];

const FireworksEffect = () => {
  return (
    <>
      <style>{`
        .firework {
          position: absolute;
          width: 10px;
          height: 10px;
          animation: fw-cycle 3s ease-out infinite;
        }

        @keyframes fw-cycle {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          10% {
            transform: scale(1);
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }

        .core {
          position: absolute;
          inset: -20px;
          border-radius: 50%;
          background: radial-gradient(
            circle,
            rgba(255,255,255,1),
            rgba(255,200,80,0.8),
            rgba(255,200,80,0)
          );
          filter: blur(6px);
          animation: core-flash 3s ease-out infinite;
        }

        @keyframes core-flash {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          12% {
            transform: scale(1);
            opacity: 1;
          }
          30% {
            opacity: 0;
          }
          100% {
            opacity: 0;
          }
        }

        .particle {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 4px;
          height: 26px;
          background: linear-gradient(
            to top,
            rgba(255,180,40,0),
            rgba(255,220,120,1)
          );
          transform-origin: center bottom;
          filter: drop-shadow(0 0 6px rgba(255,220,120,1));
          animation: explode 2.2s cubic-bezier(.15,.8,.25,1) infinite;
        }

        @keyframes explode {
          0% {
            transform:
              rotate(calc(var(--i) * 8deg))
              translateY(0)
              scale(0);
            opacity: 1;
          }
          20% {
            opacity: 1;
          }
          100% {
            transform:
              rotate(calc(var(--i) * 8deg))
              translateY(-260px)
              scale(1);
            opacity: 0;
          }
        }
      `}</style>

      <div
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          overflow: 'hidden',
        }}
      >
        {bursts.map((b, i) => (
          <div
            key={i}
            className="firework"
            style={{
              top: b.top,
              left: b.left,
              animationDelay: b.delay,
            }}
          >
            <div
              className="core"
              style={{ animationDelay: b.delay }}
            />
            {Array.from({ length: 45 }).map((_, j) => (
              <span
                key={j}
                className="particle"
                style={{
                  '--i': j,
                  animationDelay: b.delay,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default FireworksEffect;
